// import React, { useState } from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   useTheme,
//   alpha,
//   Grid,
//   Card,
//   CardContent,
//   TextField,
//   InputAdornment,
//   Button,
//   Chip,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Divider,
//   Avatar,
//   Paper,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import SearchIcon from "@mui/icons-material/Search";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import ArticleIcon from "@mui/icons-material/Article";
// import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
// import ForumIcon from "@mui/icons-material/Forum";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PeopleIcon from "@mui/icons-material/People";
// import HomeIcon from "@mui/icons-material/Home";
// import WarningIcon from "@mui/icons-material/Warning";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// // import ModernPageLayout from "../shared/ModernPageLayout";
// import SupportLayout from "./SupportLayout";

// const HelpCenter = () => {
//   const theme = useTheme();
//   const [searchQuery, setSearchQuery] = useState("");

//   const categories = [
//     {
//       id: "scheduling",
//       title: "Scheduling",
//       icon: <ScheduleIcon sx={{ fontSize: 40 }} />,
//       color: theme.palette.primary.main,
//       description: "Learn how to create, manage, and optimize cleaning schedules",
//       articles: 12,
//       link: "/help/scheduling"
//     },
//     {
//       id: "payment",
//       title: "Payment & Billing",
//       icon: <PaymentIcon sx={{ fontSize: 40 }} />,
//       color: "#10b981",
//       description: "Payment methods, invoices, refunds, and pricing plans",
//       articles: 8,
//       link: "/help/payment"
//     },
//     {
//       id: "cleaners",
//       title: "Cleaners",
//       icon: <PeopleIcon sx={{ fontSize: 40 }} />,
//       color: "#f59e0b",
//       description: "Find, hire, and manage professional cleaners",
//       articles: 10,
//       link: "/help/cleaners"
//     },
//     {
//       id: "properties",
//       title: "Properties",
//       icon: <HomeIcon sx={{ fontSize: 40 }} />,
//       color: "#8b5cf6",
//       description: "Manage property details, access instructions, and amenities",
//       articles: 7,
//       link: "/help/properties"
//     },
//     {
//       id: "emergency",
//       title: "Emergency",
//       icon: <WarningIcon sx={{ fontSize: 40 }} />,
//       color: "#ef4444",
//       description: "Cancellations, damages, and urgent situations",
//       articles: 6,
//       link: "/help/emergency"
//     }
//   ];

//   const popularTopics = [
//     "How to create a cleaning schedule?",
//     "What if my cleaner cancels?",
//     "How does payment work?",
//     "Can I select a specific cleaner?",
//     "How to modify a booking?",
//     "What's included in standard cleaning?"
//   ];

//   const featuredArticles = [
//     {
//       title: "Getting Started as a Host",
//       description: "Complete guide to setting up your account and first booking",
//       readTime: "5 min read",
//       icon: <ArticleIcon />,
//       link: "/faqs"
//     },
//     {
//       title: "Video Tutorials",
//       description: "Watch step-by-step video guides for all features",
//       readTime: "15 min watch",
//       icon: <VideoLibraryIcon />,
//       link: "/help/videos"
//     },
//     {
//       title: "Community Forum",
//       description: "Connect with other hosts and share experiences",
//       readTime: "Join discussion",
//       icon: <ForumIcon />,
//       link: "/community"
//     }
//   ];

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (searchQuery.trim()) {
//       window.location.href = `/faqs?search=${encodeURIComponent(searchQuery)}`;
//     }
//   };

//   return (
//     <SupportLayout
//       title="How can we help you?"
//       category="Help Center"
//       subtitle="Find answers, watch tutorials, and connect with our support team"
//       breadcrumbs={[{ label: "Help Center" }]}
//       stats={[
//         { value: "500+", label: "Articles" },
//         { value: "24/7", label: "Support" },
//         { value: "50k+", label: "Happy Hosts" },
//         { value: "< 2min", label: "Avg Response" }
//       ]}
//     >
//       {/* Search Bar */}
//       <Paper
//         elevation={0}
//         sx={{
//           p: 1,
//           mb: 6,
//           borderRadius: 3,
//           border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           background: alpha(theme.palette.background.paper, 0.8),
//           backdropFilter: "blur(10px)",
//         }}
//       >
//         <form onSubmit={handleSearch}>
//           <TextField
//             fullWidth
//             placeholder="Search for answers..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             variant="standard"
//             InputProps={{
//               disableUnderline: true,
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ color: theme.palette.text.secondary, ml: 1 }} />
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <Button type="submit" variant="contained" sx={{ borderRadius: 2 }}>
//                     Search
//                   </Button>
//                 </InputAdornment>
//               ),
//               sx: { py: 1.5, px: 1 }
//             }}
//           />
//         </form>
//       </Paper>

//       {/* Popular Topics */}
//       <Box sx={{ mb: 6 }}>
//         <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//           Popular topics
//         </Typography>
//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//           {popularTopics.map((topic, index) => (
//             <Chip
//               key={index}
//               label={topic}
//               component={Link}
//               to={`/faqs?search=${encodeURIComponent(topic)}`}
//               clickable
//               sx={{
//                 py: 2,
//                 px: 1,
//                 fontSize: "0.9rem",
//                 background: alpha(theme.palette.primary.main, 0.05),
//                 border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                 "&:hover": {
//                   background: alpha(theme.palette.primary.main, 0.1),
//                   transform: "translateY(-2px)",
//                 },
//                 transition: "all 0.2s"
//               }}
//             />
//           ))}
//         </Box>
//       </Box>

//       {/* Help Categories */}
//       <Grid container spacing={3} sx={{ mb: 6 }}>
//         {categories.map((category) => (
//           <Grid item xs={12} sm={6} md={4} key={category.id}>
//             <Card
//               component={Link}
//               to={category.link}
//               sx={{
//                 height: "100%",
//                 textDecoration: "none",
//                 borderRadius: 3,
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   transform: "translateY(-4px)",
//                   boxShadow: theme.shadows[8],
//                 },
//                 cursor: "pointer"
//               }}
//             >
//               <CardContent sx={{ p: 3 }}>
//                 <Box
//                   sx={{
//                     width: 60,
//                     height: 60,
//                     borderRadius: 2,
//                     background: alpha(category.color, 0.1),
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     mb: 2,
//                     color: category.color
//                   }}
//                 >
//                   {category.icon}
//                 </Box>
//                 <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
//                   {category.title}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
//                   {category.description}
//                 </Typography>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                   <Chip
//                     label={`${category.articles} articles`}
//                     size="small"
//                     sx={{ background: alpha(category.color, 0.1), color: category.color }}
//                   />
//                   <ArrowForwardIcon sx={{ fontSize: 18, color: "text.secondary" }} />
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Featured Section */}
//       <Box sx={{ mb: 6 }}>
//         <Typography variant="h5" sx={{ mb: 3, fontWeight: 700, textAlign: "center" }}>
//           Featured Resources
//         </Typography>
//         <Grid container spacing={3}>
//           {featuredArticles.map((article, index) => (
//             <Grid item xs={12} md={4} key={index}>
//               <Paper
//                 component={Link}
//                 to={article.link}
//                 sx={{
//                   p: 3,
//                   textDecoration: "none",
//                   borderRadius: 3,
//                   textAlign: "center",
//                   transition: "all 0.3s ease",
//                   "&:hover": { transform: "translateY(-4px)", boxShadow: theme.shadows[4] }
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     width: 60,
//                     height: 60,
//                     bgcolor: alpha(theme.palette.primary.main, 0.1),
//                     color: theme.palette.primary.main,
//                     mb: 2,
//                     mx: "auto"
//                   }}
//                 >
//                   {article.icon}
//                 </Avatar>
//                 <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
//                   {article.title}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
//                   {article.description}
//                 </Typography>
//                 <Chip
//                   label={article.readTime}
//                   size="small"
//                   sx={{ background: alpha(theme.palette.primary.main, 0.05) }}
//                 />
//               </Paper>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>

//       {/* Contact Support CTA */}
//       <Paper
//         sx={{
//           p: 4,
//           borderRadius: 3,
//           background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.light, 0.02)} 100%)`,
//           border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//           textAlign: "center"
//         }}
//       >
//         <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
//           Still need help?
//         </Typography>
//         <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
//           Our support team is available 24/7 to assist you
//         </Typography>
//         <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
//           <Button variant="contained" component={Link} to="/contact">
//             Contact Support
//           </Button>
//           <Button variant="outlined" href="tel:+18001234567">
//             Call: 1-800-123-4567
//           </Button>
//         </Box>
//       </Paper>
//     </SupportLayout>
//   );
// };

// export default HelpCenter;



import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Button,
  Chip,
  Paper,
  Avatar,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ArticleIcon from "@mui/icons-material/Article";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import ForumIcon from "@mui/icons-material/Forum";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PaymentIcon from "@mui/icons-material/Payment";
import PeopleIcon from "@mui/icons-material/People";
import HomeIcon from "@mui/icons-material/Home";
import WarningIcon from "@mui/icons-material/Warning";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ChatIcon from "@mui/icons-material/Chat";

import SupportLayout from "./SupportLayout";

const HelpCenter = () => {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");

  const categories = [
    {
      id: "scheduling",
      title: "Scheduling",
      icon: <ScheduleIcon sx={{ fontSize: 40 }} />,
      color: theme.palette.primary.main,
      description: "Learn how to create, manage, and optimize cleaning schedules",
      articles: 12,
      link: "/faqs?category=scheduling"
    },
    {
      id: "payment",
      title: "Payment & Billing",
      icon: <PaymentIcon sx={{ fontSize: 40 }} />,
      color: "#10b981",
      description: "Payment methods, invoices, refunds, and pricing plans",
      articles: 8,
      link: "/faqs?category=payment"
    },
    {
      id: "cleaners",
      title: "Cleaners",
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      color: "#f59e0b",
      description: "Find, hire, and manage professional cleaners",
      articles: 10,
      link: "/faqs?category=cleaners"
    },
    {
      id: "properties",
      title: "Properties",
      icon: <HomeIcon sx={{ fontSize: 40 }} />,
      color: "#8b5cf6",
      description: "Manage property details, access instructions, and amenities",
      articles: 7,
      link: "/faqs?category=properties"
    },
    {
      id: "emergency",
      title: "Emergency",
      icon: <WarningIcon sx={{ fontSize: 40 }} />,
      color: "#ef4444",
      description: "Cancellations, damages, and urgent situations",
      articles: 6,
      link: "/faqs?category=emergency"
    }
  ];

  const popularTopics = [
    "How to create a cleaning schedule?",
    "What if my cleaner cancels?",
    "How does payment work?",
    "Can I select a specific cleaner?",
    "How to modify a booking?",
    "What's included in standard cleaning?"
  ];

  const featuredArticles = [
    {
      title: "Getting Started as a Host",
      description: "Complete guide to setting up your account and first booking",
      readTime: "5 min read",
      icon: <ArticleIcon sx={{ fontSize: 32 }} />,
      iconBg: "#3b82f6",
      link: "/help/getting-started"
    },
    {
      title: "Video Tutorials",
      description: "Watch step-by-step video guides for all features",
      readTime: "15 min watch",
      icon: <PlayCircleIcon sx={{ fontSize: 32 }} />,
      iconBg: "#ef4444",
      link: "/help/videos"
    },
    {
      title: "Community Forum",
      description: "Connect with other hosts and share experiences",
      readTime: "Join discussion",
      icon: <ChatIcon sx={{ fontSize: 32 }} />,
      iconBg: "#10b981",
      link: "/community"
    }
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/faqs?search=${encodeURIComponent(searchQuery)}`;
    }
  };

  return (
    <SupportLayout
      title="How can we help you?"
      category="Help Center"
      subtitle="Find answers, watch tutorials, and connect with our support team"
      breadcrumbs={[{ label: "Help Center" }]}
      stats={[
        { value: "500+", label: "Articles" },
        { value: "24/7", label: "Support" },
        { value: "50k+", label: "Happy Hosts" },
        { value: "< 2min", label: "Avg Response" }
      ]}
    >
      {/* Search Bar */}
      <Paper
        elevation={0}
        sx={{
          p: 1,
          mb: 6,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: "blur(10px)",
        }}
      >
        <form onSubmit={handleSearch}>
          <TextField
            fullWidth
            placeholder="Search for answers..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: theme.palette.text.secondary, ml: 1 }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <Button type="submit" variant="contained" sx={{ borderRadius: 2 }}>
                    Search
                  </Button>
                </InputAdornment>
              ),
              sx: { py: 1.5, px: 1 }
            }}
          />
        </form>
      </Paper>

      {/* Popular Topics */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Popular topics
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {popularTopics.map((topic, index) => (
            <Chip
              key={index}
              label={topic}
              component={Link}
              to={`/faqs?search=${encodeURIComponent(topic)}`}
              clickable
              sx={{
                py: 2,
                px: 1,
                fontSize: "0.9rem",
                background: alpha(theme.palette.primary.main, 0.05),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                "&:hover": {
                  background: alpha(theme.palette.primary.main, 0.1),
                  transform: "translateY(-2px)",
                },
                transition: "all 0.2s"
              }}
            />
          ))}
        </Box>
      </Box>

      {/* Help Categories */}
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {categories.map((category) => (
          <Grid item xs={12} sm={6} md={4} key={category.id}>
            <Card
              component={Link}
              to={category.link}
              sx={{
                height: "100%",
                textDecoration: "none",
                borderRadius: 3,
                transition: "all 0.3s ease",
                display: "flex",
                flexDirection: "column",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: theme.shadows[8],
                },
                cursor: "pointer"
              }}
            >
              <CardContent sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: 2,
                    background: alpha(category.color, 0.1),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                    color: category.color
                  }}
                >
                  {category.icon}
                </Box>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                  {category.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", mb: 2, flex: 1 }}>
                  {category.description}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: "auto" }}>
                  <Chip
                    label={`${category.articles} articles`}
                    size="small"
                    sx={{ background: alpha(category.color, 0.1), color: category.color }}
                  />
                  <ArrowForwardIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Featured Section - FIXED ALIGNMENT */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" sx={{ mb: 4, fontWeight: 700, textAlign: "center" }}>
          Featured Resources
        </Typography>
        <Grid container spacing={3}>
          {featuredArticles.map((article, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                component={Link}
                to={article.link}
                sx={{
                  p: 3,
                  textDecoration: "none",
                  borderRadius: 3,
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  minHeight: 280,
                  "&:hover": { 
                    transform: "translateY(-4px)", 
                    boxShadow: theme.shadows[8],
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                  },
                  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
              >
                {/* Icon Section */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Avatar
                    sx={{
                      width: 70,
                      height: 70,
                      bgcolor: alpha(article.iconBg, 0.1),
                      color: article.iconBg,
                      mb: 1,
                    }}
                  >
                    {article.icon}
                  </Avatar>
                </Box>

                {/* Title */}
                <Typography 
                  variant="h6" 
                  sx={{ 
                    mb: 1.5, 
                    fontWeight: 600,
                    textAlign: "center",
                    color: theme.palette.text.primary
                  }}
                >
                  {article.title}
                </Typography>

                {/* Description */}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: "text.secondary", 
                    mb: 2,
                    textAlign: "center",
                    flex: 1,
                    lineHeight: 1.6
                  }}
                >
                  {article.description}
                </Typography>

                {/* Read Time Badge - Properly aligned at bottom */}
                <Box sx={{ 
                  display: "flex", 
                  justifyContent: "center",
                  mt: "auto",
                  pt: 2
                }}>
                  <Chip
                    icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
                    label={article.readTime}
                    size="small"
                    sx={{ 
                      background: alpha(theme.palette.primary.main, 0.08),
                      color: theme.palette.primary.main,
                      fontWeight: 500,
                      '& .MuiChip-icon': {
                        fontSize: 14,
                        marginLeft: 1,
                        color: theme.palette.primary.main
                      }
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Contact Support CTA */}
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.light, 0.02)} 100%)`,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          textAlign: "center"
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
          Still need help?
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
          Our support team is available 24/7 to assist you
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <Button variant="contained" component={Link} to="/contact">
            Contact Support
          </Button>
          <Button variant="outlined" href="tel:+18001234567">
            Call: 1-800-123-4567
          </Button>
        </Box>
      </Paper>
    </SupportLayout>
  );
};

export default HelpCenter;